module.exports = __webpack_public_path__ + "img/banner01-mobile.fef50bd7.webp";